import React, { FC } from 'react';
import { SetPasswordView } from '../components';

export const SetPasswordPage: FC = () => {
  return <SetPasswordView />;
};
